import axios from '@/plugins/axios'

export default {
  async index(query = '') {
    return axios.get(`/seller/dashboard/index`)
  }
}